import Gallery from "../components/Gallery";

const GalleryPage = () => {
  return (
    <div className="container mx-auto">
      <Gallery />
    </div>
  );
};

export default GalleryPage;
